import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { compose } from 'recompose';

import Note from '../Note';

import { StyledModalContent } from './styles';

const History = ({ history }) => (
  <StyledModalContent>
    {history.map(({
      id,
      activityType,
      value,
      reason,
      note,
      createdAt,
      createdByUserName,
      createdBy,
      coachId,
    }) => (
      <Note
        key={id}
        date={createdAt}
        type={activityType}
        value={value}
        reason={reason}
        note={note}
        name={createdByUserName}
        createdUserId={createdBy}
        coachId={coachId}
      />
    ))}
  </StyledModalContent>
);

History.propTypes = {
  history: PropTypes.array.isRequired,
};

export default compose(
  observer,
)(History);
